import { useSyncExternalStore } from 'react';

import { installPromptSnapshot, subscribeInstallPrompt } from '../lib/install-prompt';

/** True while the browser holds an install prompt the page can show. */
export function useInstallPrompt(): boolean {
  return useSyncExternalStore(
    subscribeInstallPrompt,
    () => installPromptSnapshot() !== null,
    () => false,
  );
}
